// Top invoice/financial management providers in Israel.
// Each entry has: key, label (Hebrew), docs URL, and short AI-style hint where to find the API key.
export const INVOICE_PROVIDERS = [
  {
    key: "green_invoice",
    label: "חשבונית ירוקה (Green Invoice)",
    url: "https://app.greeninvoice.co.il",
    hint: "היכנסי לחשבונית ירוקה ← לחצי על התמונה שלך בפינה העליונה ← הגדרות חשבון ← ממשק API. צרי מפתח חדש וקבלי Key ID ו-Secret. שימי לב: ה-Secret מוצג רק פעם אחת!",
    fields: ["key", "secret"],
  },
  {
    key: "icount",
    label: "iCount",
    url: "https://app.icount.co.il",
    hint: "ב-iCount: הגדרות ← שירותי API ← צרי טוקן חדש. תקבלי API Token יחיד.",
    fields: ["token"],
  },
  {
    key: "morning",
    label: "Morning (לשעבר חשבשבת Online)",
    url: "https://app.morning.co.il",
    hint: "ב-Morning: הגדרות עסק ← API ← יצירת מפתח API. העתיקי את המפתח.",
    fields: ["token"],
  },
  {
    key: "rivhit",
    label: "ריווחית (Rivhit)",
    url: "https://www.rivhit.co.il",
    hint: "ב-ריווחית: כלים ← הגדרות מערכת ← חיבור API. פני לתמיכה כדי להפעיל API אם אינו זמין.",
    fields: ["key", "secret"],
  },
  {
    key: "ezcount",
    label: "EZcount",
    url: "https://app.ezcount.co.il",
    hint: "ב-EZcount: הגדרות ← אבטחה ← API Keys. צרי מפתח חדש.",
    fields: ["key", "secret"],
  },
  {
    key: "sumit",
    label: "סומיט (Sumit)",
    url: "https://app.sumit.co.il",
    hint: "ב-Sumit: הגדרות ← מפתחות API. צרי מפתח עם הרשאות יצירת מסמכים.",
    fields: ["key", "secret"],
  },
  {
    key: "cardcom",
    label: "Cardcom",
    url: "https://secure.cardcom.solutions",
    hint: "ב-Cardcom: ניהול חשבון ← פרטי חיבור API. הם יזדקקו ל-Terminal Number ו-Username.",
    fields: ["key", "secret"],
  },
  {
    key: "tranzila",
    label: "Tranzila",
    url: "https://www.tranzila.com",
    hint: "ב-Tranzila: מסך הניהול ← API. קבלי את ה-Supplier ID וה-Password.",
    fields: ["key", "secret"],
  },
  {
    key: "meshulam",
    label: "משולם (Meshulam)",
    url: "https://www.meshulam.co.il",
    hint: "ב-Meshulam: הגדרות ← API. פני לתמיכה לקבלת מפתח API.",
    fields: ["key"],
  },
  {
    key: "payplus",
    label: "PayPlus",
    url: "https://www.payplus.co.il",
    hint: "ב-PayPlus: הגדרות ← שילובי API. צרי משתמש API.",
    fields: ["key", "secret"],
  },
  {
    key: "upay",
    label: "UPay",
    url: "https://upay.co.il",
    hint: "ב-UPay: ההגדרות ← חיבור API.",
    fields: ["key"],
  },
  {
    key: "invoice4u",
    label: "Invoice4U",
    url: "https://app.invoice4u.co.il",
    hint: "ב-Invoice4U: הגדרות ← API. צרי מפתח.",
    fields: ["key"],
  },
  {
    key: "paybox",
    label: "PayBox",
    url: "https://www.payboxapp.com",
    hint: "ב-PayBox: הגדרות עסק ← API Keys.",
    fields: ["key"],
  },
  {
    key: "bit_business",
    label: "Bit Business",
    url: "https://www.bitpay.co.il",
    hint: "ב-Bit Business: לוח הבקרה ← הגדרות API.",
    fields: ["key"],
  },
  {
    key: "grow",
    label: "Grow (קופת זהב)",
    url: "https://www.growcash.co.il",
    hint: "ב-Grow: פרטי חשבון ← מפתחות API.",
    fields: ["key"],
  },
  {
    key: "pelecard",
    label: "Pelecard",
    url: "https://www.pelecard.biz",
    hint: "ב-Pelecard: ניהול חשבון ← שילוב API.",
    fields: ["key", "secret"],
  },
  {
    key: "yaad_sarig",
    label: "יעד שריג (YaadPay)",
    url: "https://www.yaad-sarig.co.il",
    hint: "ביעד שריג: ניהול חשבון ← API - קבלי Terminal ו-Hash Key.",
    fields: ["key", "secret"],
  },
  {
    key: "xero",
    label: "Xero",
    url: "https://www.xero.com",
    hint: "Xero: Developer Portal ← My Apps ← צרי App חדש ← Generate secret.",
    fields: ["key", "secret"],
  },
  {
    key: "quickbooks",
    label: "QuickBooks",
    url: "https://developer.intuit.com",
    hint: "QuickBooks: Developer Dashboard ← My Apps ← Keys & OAuth.",
    fields: ["key", "secret"],
  },
  {
    key: "zoho_invoice",
    label: "Zoho Invoice",
    url: "https://www.zoho.com/invoice/",
    hint: "Zoho: API Console ← Self Client ← Generate Code.",
    fields: ["key", "secret"],
  },
  {
    key: "other",
    label: "ספק אחר (לא ברשימה)",
    url: "",
    hint: "הזיני את שם החברה ואת פרטי ה-API בשדות הבאים. נוכל לסייע בחיבור ידני.",
    fields: ["key", "secret"],
  },
];
